module.exports = "/_next/static/images/intelligence-trends-a53a7617d5736f44c31932ef65b6161f.png";